import React from "react";
import AnnouncementsContainer from "../../../containers/admin/announcements/AnnouncementsContainer";

function PCAnnouncements() {
    return (
        <div>
            <AnnouncementsContainer />
        </div>
    );
}

export default PCAnnouncements;
